import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import {
  SEO_SITE_NAME,
  SEO_DEFAULT_DESCRIPTION,
  SEO_DEFAULT_IMAGE,
  buildTitle,
} from '../../config/seoConfig';
import { toAbsoluteUrl } from '../../utils/seoUtils';

const SEO = ({
  title,
  description,
  image,
  canonicalPath,
  type = 'website',
  noIndex = false,
  noFollow = false,
  schema,
}) => {
  const location = useLocation();
  const resolvedTitle = buildTitle(title);
  const resolvedDescription = description || SEO_DEFAULT_DESCRIPTION;
  const resolvedCanonical = canonicalPath
    ? toAbsoluteUrl(canonicalPath)
    : toAbsoluteUrl(location.pathname);
  const resolvedImage = image ? toAbsoluteUrl(image) : SEO_DEFAULT_IMAGE;
  const robots = `${noIndex ? 'noindex' : 'index'}, ${noFollow ? 'nofollow' : 'follow'}`;
  const schemas = Array.isArray(schema) ? schema : schema ? [schema] : [];

  return (
    <Helmet>
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDescription} />
      <link rel="canonical" href={resolvedCanonical} />
      <meta name="robots" content={robots} />

      <meta property="og:site_name" content={SEO_SITE_NAME} />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDescription} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={resolvedCanonical} />
      {resolvedImage ? <meta property="og:image" content={resolvedImage} /> : null}
      <meta property="og:locale" content="en_US" />

      <meta name="twitter:card" content={resolvedImage ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDescription} />
      {resolvedImage ? <meta name="twitter:image" content={resolvedImage} /> : null}

      {schemas.map((entry, idx) => (
        <script key={`ld-${idx}`} type="application/ld+json">
          {JSON.stringify(entry)}
        </script>
      ))}
    </Helmet>
  );
};

export default SEO;
